const theme = {
	colors: {
		light100: "#E6E6FF",
		light200: "#ccccff",
		light300: "#b3b3ff",
		dark100: "#000019",
		dark200: "#000033",
		dark300: "#00004c",
		cartItemBody: "#8080ff",
		cartItemHead: "#000080",
	},
};

export default theme;
